import React from "react";
import "../../css/my style.css";
import "../../css/my style3.css";
import "../../components/my script";
import Sidenav from "../../components/Sidenav/XMLSidenav";
import Navbar from "../../components/navbar";
import Footertutorials from "../../components/Footer-tutorials";
import SyntaxHighlighterComponent from "../../components/SyntaxHighlighterComponent";
import { Helmet } from "react-helmet";
import ButtonNext from "../../components/Buttonnext";
import ButtonPrevious from "../../components/Buttonprevious";
import ScrollToTopLink from "../../components/ScrollToTop";

export default function XMLXPath() {
  const newCode = {
    padding: '20px',
    textAlign: 'left',
    background: 'white',
    color: 'black'
  };

  const example1 = `
<bookstore>
  <book category="cooking">
    <title lang="en">Everyday Nigerian</title>
    <author>Uche Anyanwu</author>
    <year>2008</year>
    <price>31.00</price>
  </book>
  <book category="children">
    <title lang="en">Harry Potter</title>
    <author>J K. Rowling</author>
    <year>2005</year>
    <price>29.99</price>
  </book>
</bookstore>
`;

  const example2 = `
XPath: /bookstore/book/title
Result: 
<title lang="en">Everyday Nigerian</title>
<title lang="en">Harry Potter</title>
`;

  const example3 = `
XPath: //title[@lang='en']
Result: 
<title lang="en">Everyday Nigerian</title>
<title lang="en">Harry Potter</title>
`;

  return (
    <body>
      <Helmet>
        <title>XPath Tutorial</title>
        <meta charset="UTF-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="keywords" content="XML XPath, XML Tutorial, XML Data Querying" />
        <meta name="description" content="Learn how to use XPath for querying XML data with examples and explanations of the syntax and usage." />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <br />
      <br />
      <br />
      <br />
      <br />
      <Sidenav />
      <div className="content">
        <header className="headertutorials" style={newCode}>
        <ScrollToTopLink to="/XML_data_transformation"><ButtonPrevious /></ScrollToTopLink>
        <ScrollToTopLink to="/XML_xpath_expressions"><ButtonNext /></ScrollToTopLink>
          <h1>XPath Tutorial</h1>
        </header>
        <Navbar />
        <main>
          <section>
            <p>XPath is a language for selecting nodes from an XML document. It can be used to navigate through elements and attributes in an XML document.</p>

            <h2>Example 1: Basic XML Structure</h2>
            <SyntaxHighlighterComponent code={example1} language="xml" />
            <p>This example shows a basic XML structure with a bookstore containing books. We will use XPath to query this data.</p>

            <h2>Example 2: Simple XPath Query</h2>
            <SyntaxHighlighterComponent code={example2} language="xml" />
            <p>This example demonstrates a simple XPath query that selects all the titles in the bookstore.</p>

            <h2>Example 3: XPath with Conditions</h2>
            <SyntaxHighlighterComponent code={example3} language="xml" />
            <p>This example demonstrates an XPath query with a condition that selects titles with a specific language attribute.</p>

            <h2>Understanding XPath</h2>
            <p>XPath expressions are used to navigate through elements and attributes in an XML document. They are used extensively in XSLT and other XML-related technologies.</p>

            <ul>
              <li><strong>Basic XPath Syntax:</strong> <code>/</code> for absolute path, <code>//</code> for relative path, <code>@</code> for attributes.</li>
              <li><strong>Common Use Cases:</strong> Selecting specific elements, filtering elements based on conditions, navigating through complex XML structures.</li>
            </ul>
          </section>
        </main>
        <div className="head">
          <ScrollToTopLink to="/XML_data_transformation"><ButtonPrevious /></ScrollToTopLink>
          <ScrollToTopLink to="/XML_xpath_expressions"><ButtonNext /></ScrollToTopLink>
        </div>
      </div>
      <Footertutorials />
    </body>
  );
}
